import { CheckIcon } from "@heroicons/react/20/solid";
import { AgentPricingTexts } from "./DataLists";
import { US, CA } from "country-flag-icons/react/3x2";

const tiers = [
  {
    name: AgentPricingTexts.tiers[0].title,
    id: "tier-business",
    href: "#",
    priceMonthly: AgentPricingTexts.tiers[0].price,
    description: AgentPricingTexts.tiers[0].description,
    features: AgentPricingTexts.tiers[0].perks,
    button: AgentPricingTexts.tiers[0].button,
  },
  {
    name: AgentPricingTexts.tiers[1].title,
    id: "tier-first-class",
    href: "#",
    priceMonthly: AgentPricingTexts.tiers[1].price,
    description: AgentPricingTexts.tiers[1].description,
    features: AgentPricingTexts.tiers[1].perks,
    button: AgentPricingTexts.tiers[1].button,
  },
];

export default function PricingTiers() {
  return (
    <div className="isolate min-h-screen bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 pb-72 text-center sm:pt-32 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <h2 className="text-base font-semibold leading-7 text-indigo-400">
            {AgentPricingTexts.firstText}
          </h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            {AgentPricingTexts.secondText}
          </p>
        </div>
        <div className="relative mt-6">
          <p className="mx-auto max-w-2xl text-lg leading-8 text-white/60">
            {AgentPricingTexts.thirdText}
          </p>
          <svg
            viewBox="0 0 1208 1208"
            className="absolute -top-10 left-1/2 -z-10 h-[64rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:-top-12 md:-top-20 lg:-top-12 xl:top-0">
            <ellipse
              cx={604}
              cy={604}
              fill="url(#6d1bd035-0dd1-437e-93fa-59d316231eb0)"
              rx={604}
              ry={604}
            />
            <defs>
              <radialGradient id="6d1bd035-0dd1-437e-93fa-59d316231eb0">
                <stop stopColor="#7775D6" />
                <stop offset={1} stopColor="#E935C1" />
              </radialGradient>
            </defs>
          </svg>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-6 pb-40 pt-24 sm:pt-32 lg:px-8">
        <div className="-mt-80">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto grid max-w-md grid-cols-1 gap-8 lg:max-w-4xl lg:grid-cols-2">
              {tiers.map((tier) => (
                <div
                  key={tier.id}
                  className="flex flex-col  justify-between rounded-3xl bg-white p-8 shadow-xl ring-1 ring-gray-900/10 sm:p-10">
                  <div>
                    <h3
                      id={tier.id}
                      className="text-base font-semibold leading-7 text-indigo-600">
                      {tier.name}
                    </h3>
                    <div className="mt-4 flex items-center gap-x-2">
                      <span className="text-5xl font-bold tracking-tight text-gray-900">
                        {tier.priceMonthly}
                      </span>
                      <span className="flex items-center text-base font-semibold leading-7 text-gray-600">
                        / month + HST
                        <CA title="Canada" className="w-4 ml-2" />
                      </span>
                    </div>

                    <p className="mt-6 text-base leading-7 text-gray-600">
                      {tier.description}
                    </p>
                    <p className="mt-6 text-base leading-7 text-gray-600">
                      Includes:
                    </p>
                    <ul
                      role="list"
                      className="mt-4 space-y-4 text-sm leading-6 text-gray-600">
                      {tier.features.map((feature) => (
                        <li key={feature} className="flex gap-x-3">
                          <CheckIcon
                            className="h-6 w-5 flex-none text-indigo-600"
                            aria-hidden="true"
                          />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <a
                    href={tier.href}
                    aria-describedby={tier.id}
                    className="mt-8 block rounded-md bg-indigo-600 px-3.5 py-2 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    {tier.button}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
